import { t } from "@lingui/macro";
import { RelayEnvironmentProvider, useRelayEnvironment } from "react-relay";

import { WithRealSafeAreaInsets } from "@/hooks/useRealSafeAreaInsets";
import { StandardModal } from "@whoosh/design-system/src/components/overlay/StandardModal";

import { BookingHistoryQueryWrapper } from "./components/BookingHistoryQueryWrapper";

type BookingHistoryModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  clubName: string;
};

export const BookingHistoryModal = ({
  isOpen,
  setIsOpen,
  clubName,
}: BookingHistoryModalProps) => {
  const environment = useRelayEnvironment();
  return (
    <WithRealSafeAreaInsets>
      <StandardModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        upperTitle={t`Booking History`}
        subtitle={clubName}
        content={
          <RelayEnvironmentProvider environment={environment}>
            <BookingHistoryQueryWrapper />
          </RelayEnvironmentProvider>
        }
      />
    </WithRealSafeAreaInsets>
  );
};
